import { RecaptchaVerifier } from "firebase/auth";
import { useEffect, useRef, useState } from "react";
import { soulManager } from "../../data/managers/SoulManager";
import { useAuth } from "../../data/providers/AuthProvider";
import { authService } from "../../firebase-config";

declare global {
  interface Window {
    recaptchaVerifier?: RecaptchaVerifier;
  }
}

export function useLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [code, setCode] = useState("");
  const [step, setStep] = useState("input");
  const [error, setError] = useState("");
  const [isSubmittingEmail, setIsSubmittingEmail] = useState(false);
  const [isLogged, setLogged] = useState(false);
  const recaptchaContainerRef = useRef(null);

  const { user } = useAuth();

  const isPasswordValid = password.length >= 6;

  useEffect(() => {
    setLogged(!!user);
  }, []);

  useEffect(() => {
    if (!recaptchaContainerRef.current) return;
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        authService,
        "recaptcha-container",
        {
          size: "invisible",
          callback: () => {
            (window.recaptchaVerifier as any)?.recaptcha?.reset();
          },
          "expired-callback": () => {
            (window.recaptchaVerifier as any)?.recaptcha?.reset();
          },
          "error-callback": () => {
            (window.recaptchaVerifier as any)?.recaptcha?.reset();
          },
        }
      );
    }

    return () => {
      if (window.recaptchaVerifier) {
        try {
          window.recaptchaVerifier.clear();
        } catch (e) {}
        delete window.recaptchaVerifier;
      }
    };
  }, []);

  const handleVerifyCodeByEmail = async (e: any) => {
    e.preventDefault();
    if (!isPasswordValid) return;
    setIsSubmittingEmail(true);
    setError("");
    try {
      await soulManager.loginWithEmail({
        email,
        password,
      });
      setLogged(true);
    } catch (error: any) {
      setError(error?.message ?? "Código incorrecto");
    } finally {
      setIsSubmittingEmail(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    code,
    setCode,
    step,
    setStep,
    error,
    setError,
    isSubmittingEmail,
    setIsSubmittingEmail,
    isLogged,
    setLogged,
    isPasswordValid,
    handleVerifyCodeByEmail,
    recaptchaContainerRef,
  };
}
